const dashboard = {
    name: 'Dashboard/DashboardPage',
    path: '/',
    icon: 'mdi-view-dashboard-outline',
    label: 'label.dashboard'
};

const dealerships = {
    name: 'Dealerships/DealershipsPage',
    path: '/dealerships',
    icon: 'mdi-office-building-outline',
    label: 'label.dealerships'
};

const users = {
    name: 'Users/UsersPage',
    path: '/users',
    icon: 'mdi-account-group-outline',
    label: 'label.users'
};

const tireSets = {
    name: 'TireSets/TireSetsPage',
    path: '/tire-sets',
    icon: 'mdi-circle-double',
    label: 'label.tire_sets'
};

const requests = {
    name: 'Requests/RequestsPage',
    path: '/requests',
    icon: 'mdi-calendar-check-outline',
    label: 'label.requests'
};

const warehouse = {
    name: 'Storage/StoragePage',
    path: '/warehouse',
    icon: 'mdi-warehouse',
    label: 'label.warehouse'
};

const customers = {
    name: 'Customers/CustomersPage',
    path: '/customers',
    icon: 'mdi-account-multiple-outline',
    label: 'label.customers'
};

const reports = {
    name: 'Reports/ReportsPage',
    path: '/reports',
    icon: 'mdi-chart-bar',
    label: 'label.reports'
};

const billing = {
    name: 'Billing/BillingPage',
    path: '/billing',
    icon: 'mdi-credit-card-outline',
    label: 'label.billing'
};

const profile = {
    name: 'Dashboard/UserProfilePage',
    path: '/profile',
    icon: 'mdi-account-outline',
    label: 'label.profile'
};

const horizon = {
    name: 'Horizon',
    path: '/horizon',
    icon: 'mdi-sun-angle',
    label: 'label.horizon',
    private: true,
    privateLabel: 'SA'
};

const pulse = {
    name: 'Pulse',
    path: '/pulse',
    icon: 'mdi-pulse',
    label: 'label.pulse',
    private: true,
    privateLabel: 'SA'
};

const telescope = {
    name: 'Telescope',
    path: '/telescope',
    icon: 'mdi-telescope',
    label: 'label.telescope',
    private: true,
    privateLabel: 'SA'
};

/**
 * Platform-context navigation (no active dealership).
 */
export const platform = (roles) => {
    if (roles.superAdmin()) {
        return [dashboard, dealerships, users];
    }

    return [dashboard];
};

/**
 * Dealership-context navigation.
 */
export const dealership = (roles) => {
    const items = [dashboard, tireSets, requests, warehouse, customers, reports];

    if (roles.superAdmin() || roles.admin()) {
        items.push(users, billing);
    }

    return items;
};

/**
 * Every navigable route, for page-title lookups.
 */
export const allRoutes = _ => {
    return [dashboard, dealerships, users, tireSets, requests, warehouse, customers, reports, billing, profile];
};

export const profileRoute = _ => profile;

export const bottomNavRoutes = _ => {
    return [
        horizon,
        pulse,
        telescope,
    ];
};
